import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import './order.css';
import { getOrderDetails, markAsClosed, resetOrderState } from "../../store/actions";
import Helpers from "../../helpers/helpers";
import MarkResolved from "../Support/MarkResolvedModal";


const ViewOrderAriba = ({ markAsClosedArry, userPermission, orderDetails }) => {
    const dispatch = useDispatch();
    const { ID } = useParams()
    const navigate = useNavigate();
    useEffect(() => {
        if (userPermission?.length > 0) {
            !userPermission?.includes("view-order") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetOrderState());
        return () => {
            dispatch(resetOrderState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch(getOrderDetails({ id: ID }));
    }, [ID])

    useEffect(() => {
        if (markAsClosedArry?.code === 'success') {
            setNotification({
                open: true,
                msg: "Order marked as closed successfully.",
                type: "success",
            });
            dispatch(getOrderDetails({ id: ID }));
            dispatch(resetOrderState());
            setMarkResolvedOpen(false);
        }
    }, [markAsClosedArry])

    const [loading, setIsLoading] = useState(false);
    const [orderDetailData, setOrderDetailData] = useState(false);
    const [markResolvedOpen, setMarkResolvedOpen] = useState(false);
    const [subtotal, setSubtotal] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        if (orderDetails?.code === 'success') {
            let orderTempDetail = orderDetails?.data;
            let subtotal = 0;
            let total_discount = 0;

            orderTempDetail?.items?.length > 0 && orderTempDetail?.items.map((el, idx) => {
                el.view_specs = false;
                el?.variants?.length > 0 && el.variants.map((variant, idx) => {
                    subtotal += (variant?.add_price || 0) * (variant?.quantity || 1);
                })
                el?.addons?.length > 0 && el.addons.map((addon, idx) => {
                    subtotal += addon?.total || 0;
                })
                el?.services?.length > 0 && el?.services.map((service, idx) => {
                    subtotal += (service?.price || 0);
                })
                subtotal += el?.total || 0;

            })

            orderDetails.data?.applied_promocodes?.length > 0 && orderDetails.data?.applied_promocodes.map((promo, idx) => {
                total_discount += promo?.discount_value;
            })
            orderDetails.data?.applied_vouchers?.length > 0 && orderDetails.data?.applied_vouchers.map((voucher, idx) => {
                total_discount += voucher?.discount_value;
            })
            setTotalDiscount(total_discount);
            setSubtotal(subtotal);
            setOrderDetailData(orderTempDetail);
        }
    }, [orderDetails])

    const handleViewSpecs = (index, field, val) => {
        let tempArr = orderDetailData;
        let tempItemArr = orderDetailData?.items;
        tempItemArr[index][field] = val;
        tempArr.items = tempItemArr;
        setOrderDetailData({ ...tempArr });
    }

    const renderHeader = () => {
        return (
            <Grid container>
                <Grid item xs={12} sm={10} display={'flex'} alignItems={'center'}>
                    <Link to={"/order"}>
                        <CustomButton
                            title={<i className="ri-arrow-left-line" style={{ fontSize: 20 }} />}
                            press={() => ""}
                            backgroundColor={'transparent'}
                            textColor={'#999999'}
                            borderStyle={"1px solid #D0D0D0"}
                            paddingInline={12}
                            padding={5}
                        />
                    </Link>
                    <div style={{ fontSize: 24, marginLeft: 10 }}>Order <span className="header">#{ID}</span></div>
                </Grid>
                <Grid item xs={12} sm={2} justifyContent={'flex-end'} display={"flex"}>
                    {
                        orderDetailData?.status === 'pending' &&
                        <CustomButton
                            title={'Mark as Closed'}
                            backgroundColor={'#34C759'}
                            textColor={'white'}
                            borderStyle={'1px solid #34C759'}
                            press={() => setMarkResolvedOpen(true)}
                        />
                    }
                </Grid>
            </Grid>
        )
    }

    const renderCustomerInfo = () => {
        return (
            <Card className="p-3 mt-4">
                <CardBody>
                    <div className="header-2">Order #{ID}</div>
                    <Grid container className="d-flex mt-2" spacing={1}>
                        <Grid item lg={3} xs={12}><span className="text-semibold">Platform: </span> Ariba Ecommerce Platform</Grid>
                        <Grid item lg={3} xs={12}><span className="text-semibold">Placed on: </span> {orderDetailData?.placed_on || '-'}</Grid>
                        <Grid item lg={6} xs={12}><span className="text-semibold">Last modified: </span> {orderDetailData?.last_modified || '-'}</Grid>
                    </Grid>
                    <Divider className="mt-3" />
                    <Grid className="curve-container mt-4" container spacing={1}>
                        <Grid item sm={12} xs={12} className="mb-2 text-bold">Customer</Grid>
                        <Grid item sm={2} xs={12} className="subheader-2">Name:</Grid>
                        <Grid item sm={10} xs={12} >{orderDetailData?.customer_name || '-'}</Grid>
                        <Grid item sm={2} xs={12} className="subheader-2">Email address:</Grid>
                        <Grid item sm={10} xs={12}>{orderDetailData?.customer_email || '-'}</Grid>
                        <Grid item sm={2} xs={12} className="subheader-2">Phone number:</Grid>
                        <Grid item sm={10} xs={12}>{orderDetailData?.customer_phone || '-'}</Grid>
                        <Grid item sm={2} xs={12} className="subheader-2">Company:</Grid>
                        <Grid item sm={10} xs={12}>{orderDetailData?.shipping_company || '-'}</Grid>
                    </Grid>
                </CardBody>
            </Card>
        )
    }


    const renderItemService = (data) => {

        return (
            <>
                <div style={{ paddingTop: 10 }}>
                    <div className="text-bold py-0 mt-2 mb-1" style={{ width: '100%', fontSize: 13, textAlign: 'left' }}>
                        {`Service & Warranty`}
                    </div>
                </div>
                {
                    data?.length > 0 && data.map((item, idx) => {
                        let year = (item?.months && (item.months / 12)) || 0;
                        return (
                            <div style={{ width: '100%' }} className="mt-1 d-flex">
                                <div style={{ width: '56%' }}>
                                    <div className="font-size-14">{item?.service_name} - {item?.service_type_name}</div>
                                    <div className="subheader-2 font-size-12">{year} {year > 1 ? 'years' : 'year'}</div>
                                </div>
                                <div style={{ width: '24%' }}></div>
                                <div style={{ width: '10%', textAlign: 'right' }}>X{item?.quantity || '1'}</div>
                                <div style={{ width: '10%', textAlign: 'right' }}>S$ {Number(item?.price || 0).toFixed(2)}</div>
                            </div>
                        )
                    })
                }
            </>
        )
    }
    const renderItemAddOn = (data) => {
        return (
            <>
                <div className="text-bold py-0 mt-2 mb-1" style={{ width: '100%', fontSize: 13, textAlign: 'left' }}>
                    {`Add On (${data?.length || '0'} ${data?.length > 1 ? 'items' : 'item'})`}
                </div>
                {
                    data?.length > 0 && data.map((item, idx) => {
                        return (
                            <div style={{ width: '100%' }} className="mt-1 d-flex">
                                <div style={{ width: '56%' }}>
                                    <div className="font-size-14">{item?.product_name}</div>
                                    <div className="subheader-2 font-size-12">SKU: {item?.product_sku}</div>
                                </div>
                                <div style={{ width: '24%', textAlign: 'right' }}>
                                    <div> S$ {Number((item?.price || 0) - (item?.discount_amount || 0)).toFixed(2)}</div>
                                    {item?.discount_amount && <div style={{ textDecorationLine: 'line-through', color: '#999999' }}> S$ {item?.price && Number(item?.price).toFixed(2)}</div>}
                                </div>
                                <div style={{ width: '10%', textAlign: 'right' }}>X{item?.quantity || '0'}</div>
                                <div style={{ width: '10%', textAlign: 'right' }}>S$ {Number((item?.total || 0)).toFixed(2)}</div>
                            </div>
                        )
                    })
                }
            </>
        )
    }
    const renderItemGift = (data) => {
        return (
            <>
                <div style={{ paddingTop: 10 }}>
                    <div className="text-bold py-0 mt-2 mb-1" style={{ width: '100%', fontSize: 13, textAlign: 'left' }}>
                        {`Free Gift (${data?.length || '0'} ${data?.length > 1 ? 'items' : 'item'})`}
                    </div>
                </div>
                <div style={{}}>
                    {
                        data?.length > 0 && data.map((item, idx) => {
                            return (
                                <div style={{ width: '100%' }} className="mt-1 d-flex">
                                    <div style={{ width: '56%' }}>
                                        <div className="font-size-14">{item?.product_name}</div>
                                        <div className="subheader-2 font-size-12">SKU: {item?.sku}</div>
                                    </div>
                                    <div style={{ width: '24%' }}></div>
                                    <div style={{ width: '10%', textAlign: 'right' }}>X{item?.quantity || '0'}</div>
                                    <div style={{ width: '10%', textAlign: 'right' }}>FREE</div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        )
    }

    const renderItemOrdered = (itemData, index) => {
        return (
            <>
                <div style={{ flexDirection: 'row', display: 'flex', width: '100%', paddingBlock: 10 }}>
                    <div style={{ width: '8%' }}>
                        <img src={itemData?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 58, maxWidth: '100%', objectFit: 'contain' }} />
                    </div>
                    <div style={{ width: '48%', textAlign: 'left', marginLeft: 10 }}>
                        <div className="subheader d-flex">{itemData?.product_name || 'N/A'}</div>
                        <div className="subheader-2 font-size-12">SKU: {itemData?.sku || '-'}</div>
                    </div>
                    <div style={{ width: '24%', textAlign: 'right' }}>
                        <div> S$ {Number((itemData?.subtotal / itemData.quantity || 0) - (itemData?.discount_amount / itemData.quantity || 0)).toFixed(2)}</div>
                        {itemData?.discount_amount !== 0 && <div style={{ textDecorationLine: 'line-through', color: '#999999' }}> S$ {itemData?.subtotal && Number(itemData?.subtotal / itemData.quantity).toFixed(2)}</div>}
                    </div>
                    <div style={{ width: '10%', textAlign: 'right' }}>X{itemData?.quantity || '0'}</div>
                    <div style={{ width: '10%', textAlign: 'right' }}>S$ {itemData?.total && Number(itemData.total).toFixed(2)}</div>
                </div>
                {
                    itemData?.variants?.length > 0 &&
                    <div className="my-3" style={{ width: '100%' }}>
                        <div className="clickable-text" onClick={() => handleViewSpecs(index, 'view_specs', !itemData?.view_specs)}>
                            {!itemData?.view_specs ? 'View Specs' : 'Hide Specs'}
                        </div>
                        {
                            itemData?.view_specs &&
                            <div className="mt-1 mb-2" style={{ color: '#686868', fontSize: 12 }}>
                                {
                                    itemData?.variants.map((variant, idx) => {
                                        return (
                                            <li>
                                                <span style={{ fontFamily: 'Manrope-Bold' }}>{variant?.configuration_text}</span>: {variant?.quantity > 1 && <span>{variant.quantity}x</span>} {variant?.configuration_item_text}
                                                {variant?.add_price > 0 && <span style={{ color: '#ED1A3D', fontFamily: 'Manrope-Bold' }}> (+S$ {variant.add_price * (variant?.quantity || 1)})</span>}
                                            </li>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                }
                {
                    (itemData?.addons?.length > 0 || itemData?.gifts?.length > 0 || itemData?.services?.length > 0) &&
                    <div className="mt-3 mb-2 text-semibold" style={{ width: '100%' }}>
                        Item Included
                    </div>
                }
                {/* start loop add on item */}
                {itemData?.addons?.length > 0 && renderItemAddOn(itemData.addons)}
                {itemData?.gifts?.length > 0 && renderItemGift(itemData.gifts)}
                {itemData?.services?.length > 0 && renderItemService(itemData.services)}
                {/* end loop ordered item */}
                <Divider className="my-3" />
            </>
        )
    }


    const handleSubmit = () => {
        dispatch(markAsClosed({ id: ID }))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !orderDetails?.data} />
                <Notification notification={notification} setNotification={setNotification} />
                <Container fluid>
                    {renderHeader()}
                    {renderCustomerInfo()}
                    <Card className="p-3 mt-4">
                        <CardBody>
                            <div className="header-2">Item Ordered</div>
                            <Divider className="mt-2 mb-3" />
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <div style={{ flexDirection: 'row', display: 'flex', paddingTop: 10, minWidth: 800 }}>
                                    <div className="subheader" style={{ width: '56%' }}>Item Name</div>
                                    <div className="subheader" style={{ width: '24%', textAlign: 'right' }}>Price</div>
                                    <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>Quantity</div>
                                    <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>Total</div>
                                </div>
                                <div style={{ minWidth: 800 }}>
                                    <Divider className="my-3" />
                                    {orderDetailData?.items?.length > 0 && orderDetailData?.items?.map((item, idx) => {
                                        return (
                                            renderItemOrdered(item, idx)
                                        )
                                    })}
                                </div>
                                {/* <Divider className="my-3" /> */}
                            </div>
                            <div>
                                <div>Payment via {orderDetailData?.payment_method || '-'}</div>
                                <div className="subheader-2">{orderDetailData?.payment_made || '-'}</div>
                            </div>
                            <Divider className="my-3" />
                            <Grid container textAlign={'right'} spacing={0.5} mt={2}>
                                <Grid item md={6} sm={6} xs={6} textAlign={'left'}>Subtotal</Grid>
                                <Grid item md={6} sm={6} xs={6}>S$ {Number(subtotal).toFixed(2) || '0.00'}</Grid>
                                <Grid item md={6} sm={6} xs={6} textAlign={'left'}>
                                    Discount
                                    {
                                        orderDetailData?.applied_promocodes &&
                                        <div style={{ color: '#999999', display: 'flex', flexWrap: 'wrap' }}>
                                            <i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{orderDetailData.applied_promocodes}
                                        </div>
                                    }
                                    {
                                        orderDetailData?.applied_vouchers &&
                                        <div style={{ color: '#999999', display: 'flex', flexWrap: 'wrap' }}>
                                            <i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{orderDetailData.applied_vouchers}
                                        </div>
                                    }
                                    {/* {
                                        (orderDetailData?.applied_promocodes?.length > 0 || orderDetailData?.applied_vouchers?.length > 0) &&
                                        <span style={{ color: '#999999' }}>
                                            {
                                                orderDetailData?.applied_promocodes?.length > 0 && orderDetailData?.applied_promocodes?.map((promo, idx) => {
                                                    return (
                                                        <><i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{promo?.code}</>
                                                    )
                                                })
                                            }
                                            {
                                                orderDetailData?.applied_vouchers?.length > 0 && orderDetailData?.applied_vouchers?.map((voucher, idx) => {
                                                    return (
                                                        <><i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{voucher?.caption}</>
                                                    )
                                                })
                                            }
                                        </span>
                                    } */}
                                </Grid>
                                <Grid item md={6} sm={6} xs={6}>-S$ {orderDetailData?.discount_amount ? Number(orderDetailData?.discount_amount).toFixed(2) : '0.00'}</Grid>
                                <Grid item md={6} sm={6} xs={6} textAlign={'left'}>Shipping</Grid>
                                <Grid item md={6} sm={6} xs={6}>{orderDetailData?.shipping_fee == (0 || 0.00) ? 'FREE' : `S$${Number(orderDetailData?.shipping_fee).toFixed(2)}`}</Grid>
                                <Grid item md={6} sm={6} xs={6} className="text-bold" textAlign={'left'} >Total</Grid>
                                <Grid item md={6} sm={6} xs={6} className="text-bold">S$ {Number(orderDetailData?.order_amount || 0).toFixed(2)}</Grid>
                            </Grid>
                        </CardBody>
                    </Card>
                    <MarkResolved
                        open={markResolvedOpen}
                        close={() => setMarkResolvedOpen(false)}
                        submit={() => handleSubmit()}
                        selectedInquiry={orderDetailData}
                        module={"order"}
                        type={"Closed"}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Order }) {
    return {
        userPermission: Login.permissionArry,
        orderDetails: Order?.orderDetails,
        markAsClosedArry: Order?.markOrderAsClosed,
    };
}

export default connect(mapStateToProps)(ViewOrderAriba);